<div class="text-center mt-5 py-5 bg-white">
    <h1><i class="far fa-check-circle excellent"></i></h1>

    <h1 class="pt-3">{{ 'awesome' | translate }}</h1>

    <h2 class="pt-2">{{ 'payment_successful' | translate }}</h2>

    <p class="pt-3">{{ 'incoming_receipt' | translate }}</p>

    <h2 class="pt-3"><i class="fal fa-file-invoice"></i></h2>
</div>